<template>
  <el-table
    v-loading="isLoading"
    :default-sort="{ prop: 'type', order: 'ascending' }"
    :data="data"
    border
    stripe
  >
    <el-table-column
      prop="type"
      label="Type"
      min-width="300"
    >
      <template slot-scope="{ row }">
        <span>{{ getDisplayName(row.type) }}</span>
      </template>
    </el-table-column>

    <el-table-column
      prop="platform"
      label="Platform"
      width="100"
    >
      <template slot-scope="{ row }">
        <span>{{ getDisplayName(row.platform) }}</span>
      </template>
    </el-table-column>

    <el-table-column
      fixed="right"
      label="Action"
      align="center"
      width="65"
    >
      <template slot-scope="{ row }">
        <el-button
          size="mini"
          type="warning"
          icon="el-icon-edit"
          circle
          @click="onClickEdit(row)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'FeaturedListTable',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getDisplayName(type) {
      return this.$t(`featured.${type}`);
    },
    onClickEdit(row) {
      this.$router.push({ path: `featured-items/edit/type/${row.type}/platform/${row.platform}` })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
